// extracted by mini-css-extract-plugin
module.exports = {"container":"PageSpinner_container___bYPr"};